import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const Tap2Mine: FC<SvgIconProps> = ({ sx, ...props }) => (
  <SvgIcon
    viewBox="0 0 32 32"
    sx={{
      fill: 'none',
      width: '32px',
      height: '32px',
      ...sx,
    }}
    {...props}
  >
    <path
      d="M12.6588 3.99414V6.39514C12.6255 6.79921 12.9223 7.15535 13.3257 7.19547H18.6613C19.0647 7.15535 19.3615 6.79921 19.3282 6.39514V3.99414"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.9955 28.0041H10.66C9.18659 28.0041 7.99219 26.8097 7.99219 25.3364V6.66192C7.99219 5.18855 9.18659 3.99414 10.66 3.99414H21.3311C22.8044 3.99414 23.9989 5.18855 23.9989 6.66192V14.6653"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.3327 28.0032C20.7543 28.0032 18.6641 25.913 18.6641 23.3346C18.7027 20.7724 20.7704 18.7047 23.3327 18.666C25.9111 18.666 28.0013 20.7562 28.0013 23.3346C28.0013 25.913 25.9111 28.0032 23.3327 28.0032"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
